import { render, staticRenderFns } from "./CareSystem.vue?vue&type=template&id=f501ddd8&scoped=true&"
import script from "./CareSystem.vue?vue&type=script&lang=js&"
export * from "./CareSystem.vue?vue&type=script&lang=js&"
import style0 from "./CareSystem.vue?vue&type=style&index=0&id=f501ddd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f501ddd8",
  null
  
)

export default component.exports